module.exports = __webpack_public_path__ + "img/light_ic_creation_step3.ca392fe6.png";